var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "myHead" },
    [
      _c(
        "v-app-bar",
        {
          staticStyle: { background: "transparent", height: "00px" },
          attrs: { dark: "" },
        },
        [
          !_vm.isHome
            ? _c(
                "v-btn",
                {
                  staticStyle: { "flex-grow": "0" },
                  attrs: { icon: "" },
                  nativeOn: {
                    "&click": function ($event) {
                      return _vm.goBack.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "v-icon",
                    { staticClass: "myBlack", attrs: { medium: "" } },
                    [_vm._v("mdi-chevron-left")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.isHome
            ? _c(
                "v-btn",
                {
                  staticStyle: { "flex-grow": "0" },
                  attrs: { icon: "" },
                  nativeOn: {
                    "&click": function ($event) {
                      return _vm.menuClicked.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "v-icon",
                    { staticClass: "myBlack", attrs: { medium: "" } },
                    [_vm._v("mdi-menu")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass:
                "d-inline-block text-left pl-1 flex-shrink-1 overflow-hidden titleFont pointer",
              on: {
                "&click": function ($event) {
                  return _vm.gotoHome.apply(null, arguments)
                },
              },
            },
            [
              _c("img", {
                staticClass: "mr-2 sharpImage",
                staticStyle: { height: "80px", "margin-top": "5px" },
                attrs: { src: require("../assets/placeholder6-opti.png") },
              }),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "text-right headIcons",
              staticStyle: { "flex-shrink": "0" },
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "rounded100",
                  attrs: { icon: "" },
                  nativeOn: {
                    "&click": function ($event) {
                      return _vm.gotoHome.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "v-icon",
                    { staticClass: "myBlack", attrs: { medium: "" } },
                    [_vm._v("mdi-home")]
                  ),
                ],
                1
              ),
              _vm.$store.getters.inhouse && _vm.$store.state.enableKellnerruf
                ? _c(
                    "v-btn",
                    {
                      staticClass: "rounded100",
                      attrs: { icon: "" },
                      nativeOn: {
                        "&click": function ($event) {
                          return _vm.goKellnerruf.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "dotImg soloInvert",
                        attrs: { src: require("../assets/icons/waiter.png") },
                      }),
                    ]
                  )
                : _vm._e(),
              _vm.$store.state.enableNews
                ? _c(
                    "v-btn",
                    {
                      staticClass: "hidden-xs-only rounded100",
                      attrs: { icon: "" },
                      nativeOn: {
                        "&click": function ($event) {
                          return _vm.gotoAktuelles.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "myBlack", attrs: { medium: "" } },
                        [_vm._v("mdi-alert-decagram")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    "&click": function ($event) {
                      return _vm.gotoFoods.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "v-icon",
                    { staticClass: "myBlack", attrs: { medium: "" } },
                    [_vm._v("mdi-silverware-fork-knife")]
                  ),
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    "&click": function ($event) {
                      return _vm.gotoDrinks.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "v-icon",
                    { staticClass: "myBlack", attrs: { medium: "" } },
                    [_vm._v("mdi-beer")]
                  ),
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  staticClass: "hidden-sm-and-down rounded100",
                  attrs: { icon: "" },
                  nativeOn: {
                    "&click": function ($event) {
                      return _vm.goLastOrders.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "v-icon",
                    { staticClass: "myBlack", attrs: { medium: "" } },
                    [_vm._v("mdi-history")]
                  ),
                ],
                1
              ),
              _vm.itemsCount > 0
                ? _c(
                    "v-badge",
                    {
                      staticClass: "cart animated",
                      attrs: {
                        color: "#000000",
                        content: _vm.itemsCount,
                        overlap: "",
                        "offset-x": "20",
                        "offset-y": "20",
                      },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "rounded100",
                          attrs: { icon: "" },
                          nativeOn: {
                            "&click": function ($event) {
                              return _vm.gotoCart.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "myBlack", attrs: { medium: "" } },
                            [_vm._v("mdi-cart")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "v-btn",
                    {
                      staticClass: "rounded100",
                      attrs: { icon: "" },
                      nativeOn: {
                        "&click": function ($event) {
                          return _vm.gotoCart.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "myBlack", attrs: { medium: "" } },
                        [_vm._v("mdi-cart")]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.$store.getters.inhouse && _vm.$store.state.showInstallPwa
        ? _c("install")
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }